var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"main no-flex"},[_c('div',{},[(_vm.stateType == 'High')?_c('div',[_c('PassiveStockDashboardVS')],1):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }